import React, { useState } from 'react';
import logo from '../assets/logo_dark.png';
import { Menu, X } from 'lucide-react';

interface NavProps {
  activeLink?: string;
}

export const Nav: React.FC<NavProps> = ({ activeLink }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className="navbar_wrapper fixed w-full py-3 sm:py-4 z-50 bg-blue-700 backdrop-blur-md shadow-sm">
      <div className="page-padding px-4 sm:px-0">
        <div className="container-medium">
          <div className="padding-vertical padding-small">
            <div className="navbar_component flex justify-between items-center">
              <a href="/" className="navbar_logo-wrap">
                <img 
                  src={logo} 
                  alt="Syntra" 
                  className="h-10 sm:h-12"
                />
              </a>
              {/* Hamburger button for mobile */}
              <button
                className="md:hidden ml-2 p-2 rounded focus:outline-none focus:ring-2 focus:ring-white"
                onClick={() => setMenuOpen((open) => !open)}
                aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              >
                {menuOpen ? <X className="text-white" size={28} /> : <Menu className="text-white" size={28} />}
              </button>
              {/* Desktop nav links */}
              <div className="navbar_menu-wrapper hidden md:flex items-center">
                <div className="navbar_link-list flex gap-4 sm:gap-8 items-center">
                  <a 
                    href="https://security.syntra.io/"
                    target="_blank"
                    className={`navbar_link text-base sm:text-sm font-medium transition-colors duration-300 link-underline ${
                      `text-white`
                    } px-2 py-2 rounded-md`}
                  >
                    Trust Center
                  </a>
                  <a 
                    href="/deepfake"
                    className={`navbar_link text-base sm:text-sm font-medium transition-colors duration-300 link-underline ${
                      `text-white`
                    } px-2 py-2 rounded-md`}
                  >
                    Detector
                  </a>
                  <a 
                    href="/blog"
                    className={`navbar_link text-base sm:text-sm font-medium transition-colors duration-300 link-underline ${
                      `text-white`
                    } px-2 py-2 rounded-md`}
                  >
                    Blog
                  </a>
                  <a 
                    href="/careers"
                    className={`navbar_link text-base sm:text-sm font-medium transition-colors duration-300 link-underline ${
                      `text-white`
                    } px-2 py-2 rounded-md`}
                  >
                    Careers
                  </a>
                  <a 
                    href="https://zcal.co/t/syntra/assessment"
                    className="hidden md:flex button text-sm py-2 px-4 bg-white text-blue-700 hover:bg-blue-50 rounded-lg"
                  >
                    Book a demo
                  </a>
                </div>
              </div>
            </div>
            {/* Mobile menu dropdown */}
            {menuOpen && (
              <div className="md:hidden mt-2 bg-blue-700 rounded-lg shadow-lg border border-blue-600 animate-fade-in flex flex-col gap-1 p-4">
                <a 
                  href="https://security.syntra.io/"
                  target="_blank"
                  className="navbar_link text-base font-medium text-white px-2 py-3 rounded-md hover:bg-blue-800 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  Trust Center
                </a>
                <a 
                  href="/deepfake"
                  className="navbar_link text-base font-medium text-white px-2 py-3 rounded-md hover:bg-blue-800 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  Deepfake detector
                </a>
                <a 
                  href="/blog"
                  className="navbar_link text-base font-medium text-white px-2 py-3 rounded-md hover:bg-blue-800 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  Blog
                </a>
                <a 
                  href="/careers"
                  className="navbar_link text-base font-medium text-white px-2 py-3 rounded-md hover:bg-blue-800 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  Careers
                </a>
                <a 
                  href="https://zcal.co/t/syntra/assessment"
                  className="button text-base py-3 px-4 bg-white text-blue-700 hover:bg-blue-50 rounded-lg mt-2"
                  onClick={() => setMenuOpen(false)}
                >
                  Book a demo
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
